var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgService1Icon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9412_24487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9731 24H24.8265C25.9212 24.015 26.9775 23.5961 27.7644 22.8349C28.5514 22.0737 29.0051 21.032 29.0265 19.9373V15.004",
    stroke: "#5A65F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91988 7.192L18.5172 11.34C19.5043 11.6642 20.3667 12.2864 20.9856 13.1209C21.6045 13.9554 21.9495 14.9613 21.9732 16V28.0133C22.0148 28.4557 21.948 28.9016 21.7786 29.3124C21.6092 29.7232 21.3423 30.0866 21.0009 30.3711C20.6596 30.6556 20.2541 30.8527 19.8195 30.9453C19.3848 31.0379 18.9342 31.0233 18.5065 30.9027L6.44121 27.6227C5.45287 27.3152 4.58629 26.7046 3.96414 25.8774C3.34199 25.0501 2.99579 24.0482 2.97454 23.0133V9.74933C2.953 8.78128 3.31497 7.84395 3.98157 7.14163C4.64817 6.43932 5.56535 6.02896 6.53321 6H19.0265",
    stroke: "#5A65F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9731 24C17.0777 24 17.9731 23.1046 17.9731 22C17.9731 20.8954 17.0777 20 15.9731 20C14.8686 20 13.9731 20.8954 13.9731 22C13.9731 23.1046 14.8686 24 15.9731 24Z",
    stroke: "#5A65F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0264 10V2H26.0264C26.5568 2 27.0655 2.21071 27.4406 2.58579C27.8157 2.96086 28.0264 3.46957 28.0264 4C28.0264 4.53043 27.8157 5.03914 27.4406 5.41421C27.0655 5.78929 26.5568 6 26.0264 6C26.5568 6 27.0655 6.21071 27.4406 6.58579C27.8157 6.96086 28.0264 7.46957 28.0264 8C28.0264 8.53043 27.8157 9.03914 27.4406 9.41421C27.0655 9.78929 26.5568 10 26.0264 10H23.0264Z",
    stroke: "#5A65F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0264 6H26.0264",
    stroke: "#5A65F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0264 2V1",
    stroke: "#5A65F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0264 10V11",
    stroke: "#5A65F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9412_24487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(-0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService1Icon4);
export default __webpack_public_path__ + "static/media/service1-icon4.f945586e65663cec418da0d432d4642c.svg";
export { ForwardRef as ReactComponent };